import React from 'react';
import { Component } from "puzzle";
import * as _ from "lodash";
import { START_SUBMISSION_ERROR } from "../../../Viewport/ToastNotifications/Types";

type PROPS = {
  data: START_SUBMISSION_ERROR[],
}

type STATE = {
  submissions: { [reason: string]: any[] }
}

class MassStartFailedSubmissionsDialog extends Component<PROPS, STATE> {

  moduleDidMount = () => {
    const { data } = this.props;
    const groupedData: { [reason: string]: any[] } = {};

    data.forEach((item: any) => {
      if (groupedData[item.reason]) {
        groupedData[item.reason].push(item);
      } else {
        groupedData[item.reason] = [item];
      }
    });
    this.setState({ submissions: groupedData });
  }

  /**
   * Content of all related failed subs
   */
  renderContent = () => {
    const { submissions } = this.state;
    return (
      <>
        {Object.keys(submissions).map((reason: string) => (
          <div key={reason} className={'tp-warning-dialog-list'}>
            <span className={'tp-text-semibold'}>{this.translate(`reason.${reason}`)}</span>
            <ul>
              {submissions[reason].map((item: START_SUBMISSION_ERROR, index: number) => (
                <li key={reason + index}>
                  {this.translate('item', {
                    submissionId: item.submissionId,
                    submissionName: item.submissionName
                  })}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </>
    );
  };

  renderBody() {
    const { submissions = {} } = this.state;
    return (
      <>
        <span className={"tp-warning-text tp-text-semibold tp-font-size-md"}>
          {this.translate('header')}
        </span>
        {!_.isEmpty(submissions) &&
          this.renderContent()
        }
      </>
    );
  }
}

export default MassStartFailedSubmissionsDialog;
